// This service handles the custom input types definitions.

import { Injectable } from '@angular/core';
import { Observable, of, map } from 'rxjs';
import { customInputTypes } from '../../config/custom-input-types.config';
import { AvailableInputTypeV0 } from '../../models/rdsap/availableInputTypeV0';

@Injectable({
  providedIn: 'root'
})
export class CustomInputTypesDefinitionsService {
  private availableInputTypes: AvailableInputTypeV0[] = [];
  private loading = false;
  private definitions = {
    FREE_TEXT: 0,
    PARAGRAPH: 0,
    NUMERIC_INT: 0,
    NUMERIC_DEC: 0,
    CURRENCY: 0,
    DROP_DOWN: 0,
    CHECKBOX: 0,
    DATE: 0,
    YEAR: 0
  };

  private getInputTypeFromName(inputTypeName: string): number {
    const availableInputType = this.availableInputTypes.find(t => t.name === inputTypeName);
    return availableInputType ? availableInputType.id : 0;
  }

  private setDefinitions(): void {
    this.definitions.FREE_TEXT = this.getInputTypeFromName("FreeText");
    this.definitions.PARAGRAPH = this.getInputTypeFromName("Paragraph");
    this.definitions.NUMERIC_INT = this.getInputTypeFromName("NumericInt");
    this.definitions.NUMERIC_DEC = this.getInputTypeFromName("NumericDec");
    this.definitions.CURRENCY = this.getInputTypeFromName("Currency");
    this.definitions.DROP_DOWN = this.getInputTypeFromName("Dropdown");
    this.definitions.CHECKBOX = this.getInputTypeFromName("Checkbox");
    this.definitions.DATE = this.getInputTypeFromName("Date");
    this.definitions.YEAR = this.getInputTypeFromName("Year");
  }

  getDefinitions(): Observable<any> {
    this.loading = true;
    this.availableInputTypes = customInputTypes;
    this.setDefinitions();
    return of(this.definitions);
  }

  getInputTypes(): Observable<any[]> {
    if (this.availableInputTypes.length === 0) {
      return this.getDefinitions().pipe(map(() => this.availableInputTypes));
    } else {
      return of(this.availableInputTypes);
    }
  }
}
